<div #wrapper *ngIf="!inputHidden; else searchIcon"
     tabindex="1"
     class="wrapper"
     (focusout)="focusout($event)"
>
  <div class="flex m-auto" tabindex="2">
    <div>
      <div class="relative">
        <div class="absolute top-12 left-0 bg-white border rounded shadow z-10 max-h-96 inline-table">
          <div class="text-black">
            <app-global-search-result [resetCategory$]="resetCategory$" [results$]="results$"></app-global-search-result>
          </div>
        </div>
      </div>
    </div>

    <div class="flex flex-col justify-center m-auto global-search-input relative">
      <!-- <dx-text-box #globalSearch 
                   (focusout)="$event.preventDefault()"
                   autoFocus
                   (onDebouncedChange)="search($event)"
                   [label]="'common.search' | translate | ucfirst"
      ></dx-text-box> -->
      <input #globalSearch
             auto_focus
             [placeholder]="'common.globalSearch' | translate | ucfirst"
             (keyup)="keyup$.next($event)"
             class="px-10 py-1 text-black border-none"
      >
      <div class="pointer-events-none absolute w-full flex my-auto px-3">
        <span class="text-gray-400" icon="search"></span>
      </div>
      <div *ngIf="globalSearch.value.length > 0"
           class="absolute w-full flex flex-row-reverse my-auto px-3 cursor-pointer"
           (click)="globalSearch.value = ''; searchExpr$.next(''); globalSearch.focus();"
      >
        <span class="text-gray-400" icon="clear"></span>
      </div>
    </div>
  </div>
</div>
<ng-template #searchIcon>
  <div class="flex flex-col justify-center my-auto">
    <dx-button (onClick)="inputHidden=false" type="normal" stylingMode="text" icon="search" [hint]="'menu.searcher' | translate"></dx-button>
  </div>
</ng-template>